<template>
  <div id="sellerGroup">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>优惠券</el-breadcrumb-item>
          <el-breadcrumb-item>优惠券设置</el-breadcrumb-item>
          <el-breadcrumb-item>商户分组</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            navigationMap[sellerGroupActiveName]
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="pageSearch.fCustID"
                     filterable
                     clearable
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组名称::">
          <el-input placeholder="请输入分组名称"
                    v-model="pageSearch.fGroupName"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="init">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addCouponGroup"
                     v-if="is_edit">新增分组</el-button>
          <el-button type="primary"
                     size="small"
                     @click="syncAllCardGroup"
                     v-if="is_syn">批量下发</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="sellerGroupActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="商户分组列表"
                     name="sellerGroupList">
          <el-row>
            <el-table :data="pageData"
                      border
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="170"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fSelGrpName"
                               label="分组名称">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewSellerGroup(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editSellerGroup(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteSellerGroup(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="scope.row.fCustTypeID == '0' && is_syn"
                             @click="synSellerGroup(scope.$index, scope.row, false)">上传</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="synSellerGroupList">
          <el-row>
            <el-table :data="pageData"
                      border
                      :row-class-name="tableRowClassName"
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fSelGrpName"
                               label="分组名称">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column prop="fSyncRemark"
                               label="同步说明">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewSellerGroup(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editSellerGroup(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteSellerGroup(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="synSellerGroup(scope.$index, scope.row, true)"
                             v-if="is_syn">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageSearch.pageIndex"
                         @current-change="handleCurrentChange"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="sellerGroupEditOrDetail">
      <el-dialog :title="detailTitle"
                 :visible.sync="sellerGroupEditOrDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="30%">
        <el-form :model="curRowInfo"
                 class="cardGroupForm"
                 label-width="158px"
                 :rules="rules"
                 ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="客户名称::"
                            prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit || curRowInfo.op == 'edit'"
                           class="myCardGroupInput"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="分组名称::"
                            prop="fSelGrpName">
                <el-input v-model="curRowInfo.fSelGrpName"
                          placeholder="请输入分组名称"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardGroupInput"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="备注::"
                            prop="fRemark">
                <el-input type="textarea"
                          v-model="curRowInfo.fRemark"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="save_loading"
                     v-if="curRowInfo.isEdit">{{ save_msg }}</el-button>
          <el-button @click="sellerGroupEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="批量下发"
                 :visible.sync="synDataVisible"
                 width="450px"
                 v-dialogDrag>
        <el-form label-width="100px"
                 :model="syncData"
                 :rules="synRules"
                 ref="ruleForm"
                 style="margin-top:20px">
          <el-form-item label="选择客户::"
                        prop="fCustID">
            <el-select v-model="syncData.fCustID"
                       filterable
                       style="width:250px"
                       placeholder="请选择客户">
              <el-option v-for="item in batchCusts"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="syncAllOk('ruleForm')">确定</el-button>
          <el-button @click="synDataVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { coupon as api } from '../../api/coupon'
import * as user from '../../api/user'
import * as park from '../../api/park'
export default {
  name: 'sellerGroupMain',
  data () {
    return {
      loading: false,
      is_edit: false,
      is_del: false,
      is_syn: false,
      synDataVisible: false,
      save_loading: false,
      save_msg: '保存',
      navigationMap: {
        sellerGroupList: '商户分组列表',
        synSellerGroupList: '待同步'
      },
      sellerGroupEditOrDetailVisible: false,
      curRowInfo: {
        fGroupID: '',
        fCustID: '',
        fCustNo: '',
        fSelGrpName: '',
        fRemark: '',
        isEdit: false
      },
      pageSearch: {
        fCustID: '',
        fGroupName: '',
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      detailTitle: '',
      pageData: [],
      sellerGroupActiveName: 'sellerGroupList',
      fGroupNameQuery: '',
      choiceCusts: [],
      batchCusts: [],
      tableHeight: 0,
      syncData: {
        fCustID: ''
      },
      synRules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }]
      },
      rules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }],
        fSelGrpName: [{ required: true, message: '请输入分组名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    tabClick () {
      this.total = 0
      this.init()
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save_msg = '保存中…'
          this.save_loading = true
          api.saveSellerGroup(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.sellerGroupEditOrDetailVisible = false
                this.init()
                this.$message.success(data.Msg)
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }
      })
    },
    editSellerGroup (index, row) {
      this.setDefault()
      this.detailTitle = ''
      if ((row.fCustName || '').length > 0) {
        this.detailTitle = '【' + row.fCustName + '】'
      }
      this.detailTitle += '编辑商户分组：' + row.fSelGrpName
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.curRowInfo.op = 'edit'
      this.curRowInfo.isEdit = true
      this.curRowInfo.fIsSyn = this.sellerGroupActiveName === 'synSellerGroupList'
      this.sellerGroupEditOrDetailVisible = true
    },
    deleteSellerGroup (index, row) {
      this.$confirm('删除该分组【' + row.fSelGrpName + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteSellerGroup({
          fBigRowID: row.fBigRowID,
          fIsSyn: this.sellerGroupActiveName === 'synSellerGroupList'
        }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    viewSellerGroup (row) {
      this.setDefault()
      this.detailTitle = ''
      if ((row.fCustName || '').length > 0) {
        this.detailTitle = '【' + row.fCustName + '】'
      }
      this.detailTitle += '查看商户分组：' + row.fSelGrpName
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.curRowInfo.isEdit = false
      this.sellerGroupEditOrDetailVisible = true
    },
    setDefault () {
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
    },
    addCouponGroup () {
      this.setDefault()
      this.sellerGroupEditOrDetailVisible = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.curRowInfo.fHasOne = '0'
      this.detailTitle = '新增商户分组'
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
    },
    syncAllCardGroup () {
      this.syncData.fCustID = ''
      this.synDataVisible = true
    },
    syncAllOk (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let tmpCust = this.choiceCusts.filter(item => {
            if (item.fCustID === this.syncData.fCustID) {
              return item
            }
          })
          var isSyn = this.sellerGroupActiveName === 'synSellerGroupList'
          var tip =
            '将客户[' +
            tmpCust[0].fCustName +
            ']的【分组列表】商户分组，从云平台批量下发同步到线下客户端, 是否继续?'
          var synTip =
            '将客户[' +
            tmpCust[0].fCustName +
            ']的【待同步】商户分组，从云平台批量下发同步到线下客户端, 是否继续?'
          this.$confirm(isSyn ? synTip : tip, '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          })
            .then(() => {
              api.synSellerGroupById({
                fCustID: this.syncData.fCustID,
                fIsSyn: isSyn
              }).then(res => {
                if (res && res.data) {
                  let { status, data } = res
                  if (status === 200) {
                    if (data.IsOk) {
                      this.$message({
                        type: 'success',
                        message: '操作完成'
                      })
                      this.synDataVisible = false
                    } else {
                      this.$message.error('提示：' + data.Msg)
                    }
                  }
                }
              })
            })
            .catch(() => { })
        }
      })
    },
    synSellerGroup (index, row, isSyn) {
      if (row && row !== null && typeof row !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将客户[' + row.fCustName + ']的商户分组[' + row.fSelGrpName + ']' + msg + ', 是否继续?', '提示',
          {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }
        ).then(() => {
          api.synSellerGroupById({
            fBigRowID: row.fBigRowID,
            fIsSyn: isSyn
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '操作完成'
                  })
                  this.initData()
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        })
          .catch(() => { })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageData = []
      this.pageSearch.isSyn = this.sellerGroupActiveName === 'synSellerGroupList'
      api.getSellerGroupPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.total = data.Data.count
          } else {
            this.$message.error('提示：加载商户分组列表信息失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 191000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    park.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            let tmpCusts = this.choiceCusts.filter(item => {
              if (item.fCustTypeID === '0') {
                return item
              }
            })
            Object.assign(this.batchCusts, tmpCusts)
          }
        }
      }
    })
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
.sellerGroupEditOrDetail .el-radio__input.is-disabled + span.el-radio__label {
  color: #34363a;
}
.sellerGroupEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.sellerGroupEditOrDetail .el-dialog__title {
  color: white;
}
.sellerGroupEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.sellerGroupEditOrDetail .el-dialog__body {
  padding: 5px;
}
#sellerGroup .is-disabled .el-input__inner,
#sellerGroup .is-disabled .el-textarea__inner {
  color: #606266;
}
#sellerGroup .warning-row {
  color: chocolate;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
#sellerGroup .cardGroupForm {
  max-width: 500px;
  margin: 0px auto;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/coupon/sellerGroup.vue